import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

import { Url } from '../models/url.model';

@Injectable()
export class ConfigProvider {


    server: number = 1; // 1 = Produção, 2 = Homologação, 3 = Localhost
    public url = new Url();

    public CALLBACK: string = 'JSONP_CALLBACK';
    public IMAGE_DEFAULT: string = 'assets/images/default-profile.png';
    public ANO_ATUAL: number = new Date().getFullYear();

    constructor() {
        this.setUrlServer();
    }

    setUrlServer() {
        switch (this.server) {
            case 1:
                this.url.SgunBase = 'https://sgun.sogesp.org.br';
                this.url.SgunService = 'https://sgunw.sogesp.org.br/SgunService.svc/rest';
                this.url.SgunReferer = 'https://apc.sogesp.org.br';
                this.url.SgunWebServiceHost = 'https://sgunw.sogesp.org.br';
                this.url.SgunAuthorization = 'Basic NGEyNzUwNjYtNzVhMy00Zjk0LTk1ZjItMTZkZDU0NzRjNDMzOmY3ZDgxODkzLTY0ZDMtNDNmMy1iYWMxLTQ5NGU2ODJiZjBmYg==';
                this.url.Cientifico = 'https://cientifico.sogesp.org.br';
                this.url.Sogesp = 'https://www.sogesp.com.br/';
                break;
            case 2:
                this.url.SgunBase = 'https://sgun-teste.sogesp.org.br';
                this.url.SgunService = 'https://sgunw-teste.sogesp.org.br/SgunService.svc/rest';
                this.url.SgunReferer = 'http://apc-teste.sogesp.org.br';
                this.url.SgunWebServiceHost = 'http://sgunw-teste.sogesp.org.br';
                this.url.SgunAuthorization = 'Basic ZTljNmVjMDgtNzc2MS00MWM1LWJlZmYtOGJlZTQyYTI0NzQ4OmM5MjljY2RmLThhMzktNDIwMS1iMjBjLTI5MzZmNTk2ZDUzOA==';
                this.url.Cientifico = 'https://cientifico-teste.sogesp.org.br';
                this.url.Sogesp = 'http://www.sogesp.com.br/';
                break;
            case 3:
                this.url.SgunBase = 'http://localhost:14403';
                this.url.SgunService = 'http://localhost:6135/SgunService.svc/rest';
                this.url.SgunReferer = 'http://apc.sogesp.org.br';
                this.url.SgunWebServiceHost = 'http://localhost:6135';
                this.url.SgunAuthorization = 'Basic NGEyNzUwNjYtNzVhMy00Zjk0LTk1ZjItMTZkZDU0NzRjNDMzOmY3ZDgxODkzLTY0ZDMtNDNmMy1iYWMxLTQ5NGU2ODJiZjBmYg==';
                this.url.Cientifico = 'http://localhost:46669';
                //this.url.Sogesp = 'http://hm.rmcbrothers.com.br:30040/';
                this.url.Sogesp = 'http://www.sogesp.com.br/';
                break;

        }
    }

}



// WEBPACK FOOTER //
// ./src/providers/config-provider.ts